const lightbox = {
    settings : {
        selector: null,
    },

    /**
     * Moves the lightbox of parentItem to its own document body and binds the close controls.
     * Every node is resolved through parentItem.ownerDocument so the block also works inside
     * the editor canvas iframe, which is a separate document realm.
     */
    init: function( parentItem ) {

        if ( ! parentItem ) return;

        const doc          = parentItem.ownerDocument;
        const targetID     = parentItem.getAttribute( 'data-target-id' );
        const lightboxItem = parentItem.querySelector( '.lightbox' )
            || doc.querySelector( `.lightbox[data-id="${targetID}"]` );

        if ( ! lightboxItem ) return;

        this.settings.selector = lightboxItem;

        if ( lightboxItem.dataset.lightboxReady === 'true' ) return;

        lightboxItem.dataset.lightboxReady = 'true';
        doc.body.appendChild( lightboxItem );

        const lightboxClose = lightboxItem.querySelector( '.lightbox__close' );

        if ( lightboxClose ) {
            lightboxClose.addEventListener( 'click', ( event ) => { lightbox.close( parentItem, event ) } );
        }

        lightboxItem.addEventListener( 'click', ( event ) => {
            if ( event.target === lightboxItem ) {
                lightbox.close( parentItem, event );
            }
        } );
    },

    open: ( parentItem, event ) => {
        if ( event ) event.preventDefault();
        const targetID     = parentItem.getAttribute( 'data-target-id' );
        const lightboxItem = parentItem.ownerDocument.querySelector( `[data-id="${targetID}"]` );

        if ( lightboxItem ) lightboxItem.classList.add( 'active' );
    },

    close: ( parentItem, event ) => {
        if ( event ) event.preventDefault();
        const targetID     = parentItem.getAttribute( 'data-target-id' );
        const lightboxItem = parentItem.ownerDocument.querySelector( `[data-id="${targetID}"]` );

        if ( ! lightboxItem ) return;

        lightboxItem.classList.remove( 'active' );

        if ( lightboxItem.classList.contains('lightbox--video') ) {
            const video = lightboxItem.querySelector('iframe');

            if ( video ) {
                const clonedVideo = video.cloneNode(true);
                video.parentNode.replaceChild(clonedVideo, video);
            }
        }
    },
};

export default lightbox;
